import { components } from "@certn/api/generated-schemas/client-portal";
import { CascadiaColor } from "@certn/cascadia-tokens/tokens/colour";
import { ReactNode } from "react";
import { CheckData } from "../../pages/order/types";

export type OrderingUmbrellaSelectOption =
  | components["schemas"]["UmbrellaCheckSelectOption"]
  | components["schemas"]["AccountUmbrellaCheckSelectOption"];

export type OrderingCheckListChild =
  | components["schemas"]["CheckListChild"]
  | components["schemas"]["AccountCheckListChild"];

export type CardState =
  | "default"
  | "disabled"
  | "selected"
  | "selected-disabled";

export type CardConfiguration = {
  icon: (testID: string) => ReactNode;
  iconBackground: CascadiaColor;
  cardBorderSize: string;
  cardBorderColor: CascadiaColor;
  cardHasHover: boolean;
  cardHasPointer: boolean;
};

export const typesNotToAutoSelectOption = ["MOTOR_VEHICLE_RECORD"];

export interface CheckCardProps {
  name: string;
  price?: number | null;
  priceIsCatalogMinimum?: boolean;
  currency?: components["schemas"]["CurrencyEnum"];
  type: string;
  checkChildren?: OrderingCheckListChild[];
  selectOptions?: OrderingUmbrellaSelectOption[];
  turnaroundTime: string;
  disclaimersIconList?: string[];
  disclaimers?: string[];
  description: string;
  infoParagraphs?: string[][];
  coverage?: string;
  keyFeatures?: string[][];
  howItCanHelpYou?: string[][];
  selectFieldDescription?: string[][];
  selectFieldEndpoint?: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  isRequiredCheck?: boolean;
  umbrellaChecksSupported: components["schemas"]["CheckListChild"][];
  umbrellaChecksHeading?: string | null;
  onPress?: () => void;
  onRemove?: () => void;
  testID: string;
  checkOrderingError?: CheckData["check_has_ordering_error_for_customer_group"];
  onUpdateSelection?: (
    checkArguments: Record<string, unknown>,
    selectedOptions?: OrderingUmbrellaSelectOption[]
  ) => void;
  handleUpdateCheckAddOns?: (checkArguments: Record<string, unknown>) => void;
  isReadOnly?: boolean;
  width?: string | number;
  customerGroup?: string;
  selectedOptions?: OrderingUmbrellaSelectOption[];
  selectedArgument?: any;
  isLoading?: boolean;
  errors?: ReactNode;
  selectFieldInformation?: components["schemas"]["SelectFieldInformationGroup"][];
  checkArguments?: Record<string, unknown>;
  isApplicantPay?: boolean;
  isQuickscreen?: boolean;
  addOnOptions?: AddOnOption[];
  showRemoveWhenSelected?: boolean;
}

export type AddOnOption = components["schemas"]["CheckAddOnOption"];
